module.exports = __webpack_public_path__ + "img/cps_preview_es.000e8e59.png";